import {
  USER_QUESTION_STATUS_ASKED,
  USER_QUESTION_STATUS_ANSWERED,
  USER_QUESTION_STATUS_UNABLE_TO_ANSWER,
  USER_QUESTION_STATUS_HISTORICAL_NOT_KNOWN,
  USER_QUESTION_STATUS_SUBMITTED,
} from 'common/userQuestionConstants';

const renterTourListingQuestionsOptionItems = [
  {
    label: 'Asked agent/ Landlord',
    value: USER_QUESTION_STATUS_ASKED,
  },
  {
    label: 'Answered',
    value: USER_QUESTION_STATUS_ANSWERED,
  },
  {
    label: 'Unable to Answer',
    value: USER_QUESTION_STATUS_UNABLE_TO_ANSWER,
  },
];

export const questionOptionItemsToDefaultToPlaceholder = [
  USER_QUESTION_STATUS_HISTORICAL_NOT_KNOWN,
  USER_QUESTION_STATUS_SUBMITTED,
];

export default renterTourListingQuestionsOptionItems;
